import {
  Action,
  CustomTagType,
  DockType,
  ErrorCodes,
  OperationType,
  Position,
  WarningType,
  WindowType
} from "puzzle";
import GradingAndScoringDialog from "../components/Drawer/Tabs/Files/GradingAndScoring/GradingAndScoringDialog";
import CommentDialog from "../components/Drawer/Tabs/Files/GradingAndScoring/Comment/CommentDialog";

export const openGradingAndScoring: Action = [{
  name: 'gradingAndScoringDialogRequest',
  type: OperationType.action
}, {
  data: {
    template: {
      asSubName: true,
      bind: {
        targetLanguageName: `{targetLanguageDisplayName} || _.get({selectedSubmissions},"[0].targetLanguage.value")}`, // selectedSubmissions for supplierView
        batchName: `{batchName} || _.get({selectedSubmissions},"[0].batchName")`,  // selectedSubmissions for supplierView
        submissionId: '{gradeAndScoreRequestParams.submissionId}',
        phaseName: '{gradeAndScoreRequestParams.phaseName}'
      }
    }
  },
  type: OperationType.data
}, {
  className: 'xxl grading-and-scoring',
  children: [{
    render: GradingAndScoringDialog,
    propArgs: [
      'actionName',
      'filesCount',
      'phaseName',
      'responseData',
      'submissionId',
      'supplierCompletedFiles'
    ]
  }],
  items: [{
    btnName: 'submissionName',
    btnConfig: {
      args: ['submissionId', 'submissionName', 'asSubName'],
      customTagType: CustomTagType.label,
      dock: DockType.top,
      pos: Position.end
    },
    operations: []
  }, {
    btnName: 'batchName',
    btnConfig: {
      args: ['targetLanguageName', 'batchName', 'asSubName'],
      customTagType: CustomTagType.label,
      dock: DockType.top,
      pos: Position.end
    },
    operations: []
  }, {
    btnName: 'ESCAPE',
    close: false,
    operations: [{
      name: 'closeGradingAndScoring',
      type: OperationType.action
    }]
  }, {
    btnName: 'gradingAndScoring.close',
    btnConfig: {
      hidden: true,
      fillMode: 'flat',
      pos: Position.end
    }
  }, {
    close: false,
    btnName: 'gradingAndScoring.cancel',
    btnConfig: {
      fillMode: 'flat',
      pos: Position.end
    },
    operations: [{
      name: 'closeGradingAndScoring',
      type: OperationType.action
    }]
  }, {
    operations: [{
      moduleName: 'GradingAndScoringDialog',
      name: 'saveButtonHandler'
    }],
    close: false,
    btnName: 'gradingAndScoring.save',
    btnConfig: {
      hidden: true,
      themeColor: 'primary',
      pos: Position.end
    }
  }, {
    close: false,
    operations: [{
      data: {
        action: "COMPLETED"
      },
      moduleName: 'GradingAndScoringDialog',
      name: 'completeReturnHandler',
      args: ['action']
    }],
    btnName: 'gradingAndScoring.complete',
    btnConfig: {
      hidden: true,
      themeColor: 'primary',
      pos: Position.end
    }
  }, {
    operations: [{
      data: {
        action: "DEMOTED"
      },
      moduleName: 'GradingAndScoringDialog',
      name: 'completeReturnHandler',
      args: ['action']
    }],
    close: false,
    btnName: 'gradingAndScoring.return',
    btnConfig: {
      hidden: true,
      themeColor: 'primary',
      pos: Position.end
    }
  }, {
    close: false,
    btnName: 'gradingAndScoring.clearAll',
    btnConfig: {
      hidden: true,
      fillMode: 'outline',
      themeColor: 'primary',
      pos: Position.start
    },
    operations: [{
      moduleName: 'GradingAndScoringDialog',
      name: 'clearAllHandler'
    }]
  }],
  title: 'gradingAndScoring.title',
  type: OperationType.dialog
}, {
  name: 'updateGradeAndScoringDialogToolbar',
  type: OperationType.action
}];

export const closeGradingAndScoring: Action = [{
  moduleName: 'GradingAndScoringDialog',
  name: 'isDataChanged',
  type: OperationType.addOperationData
}, {
  condition: '{isDataChanged}',
  conditionOperations: [{
    name: 'exitGradingAndScoring',
    type: OperationType.action
  }],
  elseOperations: [{
    windowType: WindowType.warning,
    type: OperationType.closeWindow,
  }, {
    windowType: WindowType.dialog,
    type: OperationType.closeWindow
  }, {
    name: 'clearPromoteData',
    type: OperationType.action
  }],
  type: OperationType.conditional
}];

export const gradingAndScoringDialogRequest: Action = [{
  data: {
    template: {
      method: 'post',
      bind: {
        url: '{endpoint}',
        params: '{gradeAndScoreRequestParams}'
      }
    }
  },
  handleErrorStatuses: [
    ErrorCodes.BAD_REQUEST,
    ErrorCodes.FORBIDDEN,
    ErrorCodes.INTERNAL_SERVER_ERROR,
    ErrorCodes.NOT_FOUND,
  ],
  mappingName: 'responseData',
  type: OperationType.request
}, {
  name: 'handleRequestException',
  type: OperationType.action
}];

export const openGradingAndScoringComment: Action = [{
  data: {
    template: {
      selectedFilesTranslated: 'fileComments.selectedFiles',
      bind: {
        filesCount: '{filesCount}'
      }
    }
  },
  type: OperationType.data
}, {
  className: 'sm grading-and-scoring-comment',
  children: [{
    render: CommentDialog,
    propArgs: ['comment', 'setComment']
  }],
  items: [{
    operations: [],
    btnName: 'fileComments.selectedCounter',
    btnConfig: {
      pos: Position.start,
      args: ['selectedFilesTranslated', 'filesCount'],
      customTagType: CustomTagType.counter
    }
  }, {
    btnName: 'common.cancel',
    btnConfig: {
      fillMode: 'flat',
      pos: Position.end
    }
  }, {
    operations: [{
      moduleName: 'CommentDialog',
      name: 'addComment'
    }],
    btnName: 'fileComments.add',
    btnConfig: {
      disabled: true,
      themeColor: 'primary',
      pos: Position.end
    }
  }],
  title: 'commentGradingAndScoring.title',
  type: OperationType.dialog
}];

export const updateGradeAndScoringDialogToolbar: Action = [{
  waitForModule: true,
  moduleName: 'GradingAndScoringDialog',
  name: 'getFooterButtonsConfig',
  type: OperationType.addOperationData
}, {
  data: {
    template: {
      bind: {
        isReadOnly: '{getFooterButtonsConfig.isReadOnly}',
        disableClearAll: '{getFooterButtonsConfig.disableClearAll}'
      }
    }
  },
  type: OperationType.data
}, {
  buttons: [{
    name: 'gradingAndScoring.cancel',
    hidden: '{isReadOnly}'
  }, {
    name: 'gradingAndScoring.close',
    hidden: '!{isReadOnly}'
  }, {
    name: 'gradingAndScoring.save',
    hidden: '{isReadOnly}'
  }, {
    name: 'gradingAndScoring.clearAll',
    disabled: '{disableClearAll}',
    hidden: '{isReadOnly}'
  }, {
    name: 'gradingAndScoring.return',
    hidden: '{actionName} !== "demote"'
  }, {
    name: 'gradingAndScoring.complete',
    hidden: '{actionName} !== "promote"'
  }],
  type:
  OperationType.updateDialog
}
];

export const updateGradeAndScoringCommentsDialog: Action = [{
  buttons: [{
    name: 'fileComments.add',
    disabled: '{disableSaveButton}'
  }],
  type: OperationType.updateDialog
}];

export const applyToAllWarning: Action = [{
  persistent: ['dataItem', 'type'],
  type: OperationType.addPersistentData
}, {
  className: 'sm info footer-centered',
  warningType: WarningType.warning,
  text: 'applyToAllWarning.text',
  title: 'applyToAllWarning.title',
  items: [{
    operations: [{
      persistent: ['dataItem', 'type'],
      type: OperationType.removePersistentData
    }],
    btnName: 'common.cancel',
    btnConfig: {
      fillMode: 'flat',
      pos: Position.end
    }
  }, {
    close: false,
    operations: [{
      data: {
        forceAdd: true
      },
      moduleName: 'GradingAndScoringDialog',
      name: 'applyToAllHandler',
      args: ['dataItem', 'type', 'forceAdd']
    }, {
      persistent: ['dataItem', 'type'],
      type: OperationType.removePersistentData
    }],
    btnName: 'applyToAllWarning.confirm',
    btnConfig: {
      themeColor: 'error',
      pos: Position.end
    }
  }],
  type: OperationType.warning
}];

export const closeApplyToAllWarning: Action = [{
  name: 'updateGradeAndScoringDialogToolbar',
  type: OperationType.action
}, {
  windowType: WindowType.warning,
  type: OperationType.closeWindow
}];

export const notSameBatchPhaseAndLanguageWarning: Action = [{
  className: 'sm warning footer-centered',
  title: 'gradeAndScoreWarnings.notSameBatchPhaseAndLanguage.title',
  text: 'gradeAndScoreWarnings.notSameBatchPhaseAndLanguage.text',
  items: [{
    btnName: 'ESCAPE',
    operations: [{
      name: 'clearPromoteData',
      type: OperationType.action
    }]
  }, {
    operations: [{
      name: 'clearPromoteData',
      type: OperationType.action
    }],
    btnName: 'common.close',
    btnConfig: {
      pos: Position.end,
      fillMode: 'flat'
    }
  }],
  warningType: WarningType.warning,
  type: OperationType.warning
}];

export const missingGradesWarning: Action = [{
  persistent: ['gsValidatedData'],
  type: OperationType.addPersistentData
}, {
  className: 'sm warning footer-centered',
  title: 'gradeAndScoreWarnings.missingGrades.title',
  text: 'gradeAndScoreWarnings.missingGrades.text',
  items: [{
    operations: [{
      moduleName: 'GradingAndScoringDialog',
      name: 'afterMissingGrades',
      args: ['gsValidatedData']
    }, {
      persistent: ['gsValidatedData'],
      type: OperationType.removePersistentData
    }],
    btnName: 'common.close',
    btnConfig: {
      pos: Position.end,
      fillMode: 'flat'
    }
  }, {
    btnName: 'ESCAPE',
    operations: [{
      moduleName: 'GradingAndScoringDialog',
      name: 'afterMissingGrades',
      args: ['gsValidatedData']
    }, {
      persistent: ['gsValidatedData'],
      type: OperationType.removePersistentData
    }]
  }],
  warningType: WarningType.warning,
  type: OperationType.warning
}];

export const exitGradingAndScoring: Action = [{
  className: 'sm footer-centered',
  title: 'gradeAndScoreWarnings.exitGradingAndScoring.title',
  text: 'gradeAndScoreWarnings.exitGradingAndScoring.text',
  items: [{
    operations: [],
    btnName: 'common.cancel',
    btnConfig: {
      pos: Position.end,
      fillMode: 'flat'
    }
  }, {
    operations: [{
      windowType: WindowType.warning,
      type: OperationType.closeWindow,
    }, {
      windowType: WindowType.dialog,
      type: OperationType.closeWindow
    }, {
      name: 'clearPromoteData',
      type: OperationType.action
    }],
    btnName: 'common.exit',
    btnConfig: {
      pos: Position.end,
      themeColor: 'error'
    }
  }],
  type: OperationType.warning
}];

export const saveGradingAndScoringRequest: Action = [{
  name: 'addCommentGradingAndScoring',
  type: OperationType.action
}, {
  data: {
    template: {
      method: 'post',
      bind: {
        url: '{gsSaveRequestData.endpoint}',
        params: '{gsSaveRequestData.saveParams}'
      }
    }
  },
  handleErrorStatuses: [
    ErrorCodes.BAD_REQUEST,
    ErrorCodes.FORBIDDEN,
    ErrorCodes.INTERNAL_SERVER_ERROR,
    ErrorCodes.NOT_FOUND,
  ],
  mappingName: 'responseData',
  type: OperationType.request
}, {
  name: 'handleRequestException',
  type: OperationType.action
}];

export const saveGradingAndScoring: Action = [{
  name: 'saveGradingAndScoringRequest',
  type: OperationType.action
}, {
  windowType: WindowType.dialog,
  type: OperationType.closeWindow
}, {
  name: 'gradeAndScoreNotification',
  type: OperationType.action
}];

export const addCommentGradingAndScoring: Action = [{
  condition: '{gsSaveRequestData.commentParams}',
  conditionOperations: [{
    data: {
      template: {
        method: 'post',
        bind: {
          url: '{gsSaveRequestData.addCommentUrl}',
          params: '{gsSaveRequestData.commentParams}'
        }
      },
    },
    mappingName: 'commentsResponse',
    type: OperationType.request
  }, {
    name: 'handleRequestException',
    type: OperationType.action
  }],
  type: OperationType.conditional
}]

export const gradeAndScoreNotification: Action = [{
  data: {
    template: {
      bind: {
        toasterModuleId: `_.get({drawerState},'detached') && {appDetachedWindow} ? 'ToastNotificationsDrawer' : 'ToastNotificationsViewport'`,
        gradedFileCount: '{gsSaveRequestData.gradedFileCount}'
      }
    }
  },
  type: OperationType.data
}, {
  evaluate: true,
  moduleName: 'ToastNotifications',
  moduleId: '{toasterModuleId}',
  name: 'createGradeAndScoreNotification',
  args: ['gradedFileCount']
}, {
  name: 'refreshApp',
  type: OperationType.action
}, {
  evaluate: true,
  moduleName: 'ToastNotifications',
  moduleId: '{toasterModuleId}',
  name: 'runStackedNotifications'
}, {
  name: 'clearPromoteData',
  type: OperationType.action
}];

/**
 * G+S complete/return handler
 * Checks if comment is present on G+S dialog if it is, doesn't show mandatoryCommentDialog.
 */
export const closeGsAndContinuePromoteDemote: Action = [{
  persistent: ['gsSaveRequestData'],
  type: OperationType.addPersistentData
}, {
  condition: '_.get({gsSaveRequestData}, "commentParams.comment")',
  conditionOperations: [{
    evaluate: true,
    moduleName: '{executionModuleName}',
    name: 'prepareGsFlags',
    mappingName: 'flagForChange',
    args: ['actionName'],
    type: OperationType.addOperationData
  }, {
    data: {
      template: {
        bind: {
          comment: '_.get({gsSaveRequestData}, "commentParams.comment")'
        }
      }
    },
    evaluate: true,
    moduleName: '{executionModuleName}',
    name: 'setWarningFlags',
    args: ['flagForChange', 'comment']
  }],
  elseOperations: [{
    data: {
      flagForChange: ['gradingAndScoring']
    },
    evaluate: true,
    moduleName: '{executionModuleName}',
    name: 'setWarningFlags',
    args: ['flagForChange']
  }],
  type: OperationType.conditional
}, {
  windowType: WindowType.dialog,
  type: OperationType.closeWindow
}, {
  evaluate: true,
  name: '{promoteFilesAction}',
  type: OperationType.action
}];

export const notConfiguredGradingAndScoring: Action = [{
  className: 'sm warning footer-centered',
  title: 'gradeAndScoreWarnings.notConfiguredGradingAndScoring.title',
  text: 'gradeAndScoreWarnings.notConfiguredGradingAndScoring.text',
  items: [{
    btnName: 'ESCAPE',
    operations: [{
      name: 'clearPromoteData',
      type: OperationType.action
    }]
  }, {
    operations: [{
      name: 'clearPromoteData',
      type: OperationType.action
    }],
    btnName: 'common.close',
    btnConfig: {
      pos: Position.end,
      fillMode: 'flat'
    }
  }],
  warningType: WarningType.warning,
  type: OperationType.warning
}];

export const gradingAndScoringInvalidSelection: Action = [{
  title: 'gradeAndScoreWarnings.gradingAndScoringInvalidSelection.title',
  placeholders: {
    template: {
      bind: {
        limit: '{limit}'
      }
    },
  },
  className: 'sm warning footer-centered',
  text: 'gradeAndScoreWarnings.gradingAndScoringInvalidSelection.maxGradeAndScoreSelectionExceeded',
  items: [{
    btnName: 'ESCAPE',
    operations: [{
      condition: '{executionModuleName}',//triggered in complete/return flow
      conditionOperations: [{
        name: 'clearPromoteData',
        type: OperationType.action
      }],
      type: OperationType.conditional
    }]
  }, {
    btnName: 'common.close',
    operations: [{
      condition: '{executionModuleName}',//triggered in complete/return flow
      conditionOperations: [{
        name: 'clearPromoteData',
        type: OperationType.action
      }],
      type: OperationType.conditional
    }],
    btnConfig: {
      fillMode: 'flat',
      pos: Position.end
    },
  }],
  warningType: WarningType.warning,
  type: OperationType.warning
}];


export const filePathGradingAndScoring: Action = [{
  persistent: ['fileName'],
  type: OperationType.addPersistentData
}, {
  placeholders: {
    template: {
      bind: {
        fileName: '{fileName}',
      }
    }
  },
  title: 'filePathInfoGradingAndScoring.title',
  text: 'filePathInfoGradingAndScoring.text',
  type: OperationType.warning,
  className: 'sm file-path',
  items: [{
    btnName: 'common.close',
    btnConfig: {
      fillMode: 'flat',
      pos: Position.end
    }
  }, {
    operations: [{
      name: 'copyFileNameOrPath',
      type: OperationType.action
    }],
    btnName: 'filePathInfoGradingAndScoring.copy',
    btnConfig: {
      accessibility: {
        ariaLabel: '',
        iconAriaHidden: true
      },
      iconClass: 'tp-icon tp-copy-to-clipboard',
      themeColor: 'primary',
      pos: Position.end
    }
  }]
}];
